// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { listWidgetLocationsRequestToJson, listWidgetLocationsResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function listWidgetLocations(request) {
    const raw = await fetchRpc('conversation.v1.web_chat_widget.WebChatWidget/ListWidgetLocations', listWidgetLocationsRequestToJson(request));
    return listWidgetLocationsResponseFromJson(raw);
}
export function listWidgetLocations$(request, options) {
    return defer(() => listWidgetLocationsWithTransport$(getGlobalTransport(), request, options));
}
export function listWidgetLocationsWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.web_chat_widget.WebChatWidget/ListWidgetLocations', listWidgetLocationsRequestToJson(request), options)
        .pipe(map(resp => listWidgetLocationsResponseFromJson(resp)));
}
